import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { capitalize } from '@modernhealth/capitalize';
import { useFormInputLayout, FormInputLayout, } from '../FormInputLayout/FormInputLayout';
import * as styles from './FormInputTextarea.module.scss';
import { useFormInputStyles } from '../FormInputText/FormInputText';
const Name = 'FormInputTextarea';
export const FormInputTextarea = props => {
    const { register } = useFormContext();
    const { className, dependentFields, disabled, hint, id, label, labelledBy, name, required, componentProps: { trim, rows = 4, resize = 'vertical', spellCheck = true, ...otherComponentProps }, } = useFormInputLayout(props);
    const fieldStyles = clsx(useFormInputStyles(), styles.container, resize && styles[`resize${capitalize(resize)}`]);
    if (!id)
        return null;
    const registered = register(name, {
        disabled,
        setValueAs: trim ? value => `${value}`.trim() : undefined,
        deps: dependentFields,
    });
    return (_jsx(FormInputLayout, { className: className, "data-component": Name, disabled: disabled, fieldId: id, hint: hint, label: label, labelledBy: labelledBy, name: name, required: required, renderInput: state => {
            const { disabled, isValid, labelId, hintId } = state;
            return (_jsx("textarea", { className: fieldStyles, id: id, rows: rows, spellCheck: spellCheck, "data-invalid": !isValid, "data-disabled": disabled, "aria-labelledby": labelId, "aria-invalid": !isValid, "aria-describedby": hintId, ...otherComponentProps, ...registered }));
        } }));
};
